import { Component, OnInit, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import swal from 'sweetalert/dist/sweetalert.min.js';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from "rxjs/internal/operators";

@Component({
  selector: 'app-regis',
  templateUrl: './regis.component.html',
  styleUrls: ['./regis.component.css']
})
export class RegisComponent implements OnInit {
  // @ViewChild('openModal', { static: false }) openModal: ElementRef;
  @ViewChild('verifikasi', { static: false }) verifikasi: ElementRef;
  @ViewChild('agmmarker', { static: false }) agmmarker: ElementRef;
  @ViewChild('otpinput1', { static: false }) otpinput1: ElementRef;
  @ViewChild('otpinput2', { static: false }) otpinput2: ElementRef;
  @ViewChild('otpinput3', { static: false }) otpinput3: ElementRef;
  @ViewChild('otpinput4', { static: false }) otpinput4: ElementRef;
  @ViewChild('otpinput5', { static: false }) otpinput5: ElementRef;
  @ViewChild('otpinput6', { static: false }) otpinput6: ElementRef;


  inputPostalcode: Subject<string> = new Subject<string>();

  public prod : number = 0; 
  public period : number = 0;
  public addon : number = 0;


  constructor(
    private fb: FormBuilder,
    private mapsAPILoader: MapsAPILoader,
    public rest:ApiContentService,
    private route:ActivatedRoute,
    private router: Router
  ) { 
    this.inputPostalcode
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(model => {
          // api call
          this.getLocation(model)
      });
  }

  otpverify = true
  registerForm: any
  latitude: number
  longitude: number
  zoom: number
  submitted = false
  refid = ''
  loadingIcon:any = {}
  regis:any = []
  provinces:any = []
  cities:any = []
  districts:any = []
  subdistricts:any = []
  data_kml:any = []
  tea:any = []
  // prospekindex:any = 0
  prospekindex:any = 0
  otpinput:any = {}
  countTimeout:any = 0
  generate1:any = false
  codeotpran:any = 0

  hometype:any = []
  homestatus:any = []
  typeidentity:any = []
  typerelative:any = []

  fileData:File = null
  previewUrl:any = null
  image:any

  showRef = false
  isRef = false
  validRef = false

  // openInfo(marker: MapMarker, content:any) {
  //   this.infoContent = content
  //   this.info.open(marker)
  // }

  ngOnInit(): void {
    this.getProvince();

    this.route.queryParams.subscribe((queryParam)=>{
      this.prod = queryParam.prod;
      this.period = queryParam.period;
      this.addon = queryParam.addon; 
      //this.period = queryParam.period; 
      //console.log(queryParam);
      //console.log(this.prod);
    });

    this.refid = '';
    this.loadingIcon = {
      invalid: false,
      errcodeotp: false,
      mesgcodeotp: '',
      showFormOtp: false,
      next: false,
      postal_code: false,
    };
    this.regis = [];
    this.provinces = [];
    this.cities = [];
    this.districts = [];
    this.subdistricts = [];
    this.tea = [];
    this.prospekindex = 0
    this.otpinput = {}
    this.countTimeout = 0
    this.generate1 = false
    this.codeotpran = 0

    this.provinces = []
    this.cities = []
    this.districts = []
    this.subdistricts = []
    this.regis = {
      // "provincerow" : "",
      // "cityrow" : "",
      // "districtrow" : "",
      // "subdistrictrow" : "",
      "name" : "",
      "customer_type" : "",
      "email" : "",
      "phone_number" : "",
      "whatsapp_number" : "",
      "provincerow" : "",
      "address" : "",
      "cityrow" : "",
      "home_number" : "",
      "districtrow" : "",
      "rt" : "",
      "subdistrictrow" : "",
      "rw" : "",
      "postal_code" : "",

      "identity_image" : "",
      "identity_number" : "",
      "identity_birth" : "",
      "home_type" : "",
      "home_status" : "",
      "type_id" : "",
      "type_relative" : "",
      "name_relative" : "",
      "phone_relative" : "",

      "referral" : "",
      "agreeLocation": false,
    }
    navigator.geolocation.getCurrentPosition((position) => {
      this.latitude = position.coords.latitude
      this.longitude = position.coords.longitude
      this.zoom = 14

    });
    // const kmlUrl = './assets/gisjakarta/kml/AncolRw01.kml'
    // var kmlLayer = new google.maps.KmlLayer(this.kmlOptions)

    this.loadHomestatus()
    this.loadHometype()
    this.loadTypeidentity()
    this.loadTyperelative()
  }

  toggleRef(){
    this.regis.referral = ''
    this.showRef = !this.showRef
  }
  checkRef(){
    this.rest.checkref(this.regis.referral).subscribe((response:any) => {
      console.log(response)
      if(response.status){
        this.validRef = true
        this.isRef = true
        this.alertsuccess(response.message)
      }else{
        this.alertfailed(response.message)
      }
    })
  }
  clearRef(){
    swal({
      text: "Referral Code akan dihapus",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnClickOutside: false
    })
    .then((confirm) => {
      if (confirm) {
        this.validRef = false
        this.regis.referral = ''
        this.isRef = false
      }
    })
  }

  loadHomestatus(){
    this.rest.getSgshomestatus().subscribe((response:any) => {
      // console.log(response)
      this.homestatus = response.data
    });
  }
  loadHometype(){
    this.rest.getSgshometype().subscribe((response:any) => {
      // console.log(response)
      this.hometype = response.data
    });
  }
  loadTypeidentity(){
    this.rest.getSgstypeidentity().subscribe((response:any) => {
      // console.log(response)
      this.typeidentity = response.data
    });
  }
  loadTyperelative(){
    this.rest.getSgstyperelative().subscribe((response:any) => {
      // console.log(response)
      this.typerelative = response.data
    });
  }

  // public loadModal() {
  //   setTimeout(() => {
  //     this.opnModal()      
  //     this.generatenew()
  //   }, 500);
  // }

  // private opnModal(): void {
  //   this.openModal.nativeElement.click();
  // }

  // get f(){
  //   return this.registerForm.controls;
  // }

  getProvince(){
    const params = {
      'country_id': 1,
      'show': 'all'
    }
    this.rest.getProvince(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.provinces = response.data;

      }
    });
  }

  getCity(province:any){
    this.regis.cityrow = ""
    this.regis.districtrow = ""
    this.regis.subdistrictrow = ""
    this.regis.postal_code = ""

    const params = {
      'province_id': province.id,
      'show': 'all'
    }
    this.rest.getCity(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.cities = response.data;

      }
    });
  }

  getDistrict(city:any){
    this.regis.districtrow = ""
    this.regis.subdistrictrow = ""
    this.regis.postal_code = ""
    
    const params = {
      'city_id': city.id,
      'show': 'all'
    }
    this.rest.getDistrict(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.districts = response.data;

      }
    });
  }

  getSubdistrict(district:any){
    this.regis.subdistrictrow = ""
    this.regis.postal_code = ""

    const params = {
      'district_id': district.id,
      'show': 'all'
    }
    this.rest.getSubdistrict(params).subscribe((response:any) => {
      if (response.status) {

        this.subdistricts = response.data;

      }
    });
  }

  getPostalcode(){
    const params = {
        "province_name":this.regis.provincerow.name,
        "city_name":this.regis.cityrow.name,
        "district_name":this.regis.districtrow.name,
        "subdistrict_name":this.regis.subdistrictrow.name
    }
    // console.log(params)
    this.rest.getPostalcode(params).subscribe((response:any) => {
      // console.log(response)
      if (response.status) {

        if (response.data.length != 0) {
          this.loadingIcon.postal_code = false
          this.regis.postal_code = response.data[0].postal_code;
          this.setPostalcode(this.regis.postal_code)
        }else{
          this.loadingIcon.postal_code = true
        }

      }else{
        this.loadingIcon.postal_code = true
      }
    });

  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        // this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  markerDragEnd(event: MouseEvent) {
    console.log(event)
    this.latitude = event.coords.lat
    this.longitude = event.coords.lng

    // console.log(this.marker)
    // this.getAddress(this.latitude, this.longitude);
  }

  setPostalcode(postalcode:any){
    // console.log(postalcode)
    this.inputPostalcode.next(postalcode);

  }

  getLocation(postalcode:any){
    const params = {
      'postalcode': postalcode,
      'subdistrict_name': this.regis.subdistrictrow.name
    }
    this.data_kml = []
    this.tea = []

    this.rest.getLocationPosCode(params).subscribe((response:any) => {
      // console.log(response);
      this.latitude = parseFloat(response.data.lat)
      this.longitude = parseFloat(response.data.lon)
      this.zoom = 14



      const params2 = {
          "city_id":this.regis.cityrow.id,
          "subdistrict_name":this.regis.subdistrictrow.name
      }
      this.rest.getIkrgis(params2).subscribe((response:any) => {

        if(response.status){

          response.data.forEach((row:any) => {
            this.data_kml.push(
              {
                'src': "gis/"+row.dir + "/kml/" + row.area
              }
            )
          });
          response.data.forEach((row:any) => {
            this.data_kml.push(
              {
                'src': "gis/"+row.dir + "/kml/" + row.area_detail
              }
            )
          });
          // console.log(this.data_kml)
          this.data_kml.forEach((v:any, i:any) => {
              this.rest.getMapGeojson(v).subscribe((response:any) => {
                console.log(response);
                this.tea[i] = response.data
              });
            });

        }else{
          console.log(response);
        }

      });

      // var params = [{
      //     "src":"gisjakarta/kml/GandariaSelatanRw02.kml"
      //   },{
      //     "src":"gisjakarta/kml/GandariaSelatanRw04.kml"
      //   },{
      //     "src":"gisjakarta/kml/GandariaSelatanRw07.kml"
      //   },{
      //     "src":"gisjakarta/kml/GandariaSelatanRw02det.kml"
      //   },{
      //     "src":"gisjakarta/kml/GandariaSelatanRw04det.kml"
      //   },{
      //     "src":"gisjakarta/kml/GandariaSelatanRw07det.kml"
      //   },
      // ]
      // params.forEach((v, i) => {
      //   this.rest.getMapGeojson(v).subscribe((response:any) => {
      //     console.log(response);
      //     this.tea[i] = response.data
      //   });
      // });
    });
  }

  // checkLatlon(){
  //   const params = {
  //     // 'lat': this.latitude,
  //     // 'lon': this.longitude
  //   }
  //   console.log(params);
    
    
  //   this.rest.checkLatlon(params).subscribe((response:any) => {
  //     console.log(response);

  //     if ( response.status == false ) {
  //       alert(response.message + "\n\nTerimakasih!")
  //     }
  //   });
  // }

  checkNumber(value:any, type:any){
    var numbers = /^[0-9]+$/;
    if(value){
      if(value.match(numbers)){
      }else{
        // alert("must be number!")
        swal({
          title: "Input data",
          text: "Maaf Data harus diisi dengan angka.",
          icon: "error",
        });
        this.regis[type] = value.substring(0,value.length-1);
      }
    }
  }

  checkemail(value:any, type:any){
    var email = /^[_\.0-9a-zA-Z-]+@([0-9a-zA-Z][0-9a-zA-Z-]+\.)+[a-zA-Z]{2,6}$/i;
    if(value){
      if(value.preg_match(email)){
      }else{
        // alert("must be number!")
        swal({
          title: "Input data",
          text: "Maaf Data harus diisi dengan format email.",
          icon: "error",
        });
        //this.regis[type] = value.substring(0,value.length-1);
      }
    }
  }

  setChecklocation(event:any){
    this.regis.agreeLocation = event.target.checked;
  }

  clearOtp(otpid:any){
    this.otpinput[otpid] = ""
  }

  otp(value:any, otpid:any, nextotp:any){
    // console.log(value)
    var numbers = /^[0-9]+$/;
    // console.log(value.match(numbers))
    if(value.match(numbers))
    {
      this.otpinput[otpid] = value

      //tab

      const codeotp = this.otpinput[1] +
                      this.otpinput[2] +
                      this.otpinput[3] +
                      this.otpinput[4] +
                      this.otpinput[5] +
                      this.otpinput[6]
      if( codeotp == this.codeotpran && codeotp.length == 6 && nextotp == "last"){

        const params = {
          "otp_code": codeotp,
          "phone_number": this.regis.phone_number,
          "prospekindex": this.prospekindex
        }
        this.rest.checkOtpprospek(params).subscribe((response:any) => {
          //set otp
          if(response.status == true){
            this.otpverify = false
            //nextToOrder()
            this.verifikasi.nativeElement.click();
          }else{
            swal({
              title: "Kode Otp",
              text: response.message,
              icon: "error",
            });
          }
        });
      }else if(codeotp != this.codeotpran && codeotp.length == 6 && nextotp == "last"){
        console.log(this.codeotpran)
        console.log("siska3")
        console.log(codeotp)
        swal({
          title: "Kode Otp",
          text: "Kode Otp yang dimasukkan tidak sesuai!",
          icon: "error",
        });
      }

      if( nextotp != "last"){
        this[nextotp].nativeElement.focus()
        this[nextotp].nativeElement.value = ""
      }
    }else{
      alert("must be number!")
      this.otpinput[otpid] = ""
    }


    // var charCode = (evt.keyCode) ? evt.keyCode : evt.keyCode
    // if ( charCode > 46 && charCode < 65 || charCode > 93 && charCode < 106 ){

    //   if ( charCode == 9 ){ //tab
    //     this.otpinput[otpid] = ""
    //   }
      // this.otpinput[otpid] = evt.key

      // //tab

      // const codeotp = this.otpinput[1] +
      //                 this.otpinput[2] +
      //                 this.otpinput[3] +
      //                 this.otpinput[4] +
      //                 this.otpinput[5] +
      //                 this.otpinput[6]
      // if( codeotp == this.codeotpran && codeotp.length == 6 && nextotp == "last"){

      //   const params = {
      //     "otp_code": codeotp,
      //     "phone_number": this.regis.phone_number,
      //     "prospekindex": this.prospekindex
      //   }
      //   this.rest.checkOtpprospek(params).subscribe((response:any) => {
      //     //set otp
      //     if(response.status == true){
      //       this.verifikasi.nativeElement.click();
      //     }else{
      //       swal({
      //         title: "Kode Otp",
      //         text: response.message,
      //         icon: "error",
      //       });
      //     }
      //   });
      // }else if(codeotp != this.codeotpran && codeotp.length == 6 && nextotp == "last"){
      //   swal({
      //     title: "Kode Otp",
      //     text: "Kode Otp yang dimasukkan tidak sesuai!",
      //     icon: "error",
      //   });
      // }

      // if( nextotp != "last"){
      //   this[nextotp].nativeElement.focus()
      //   this[nextotp].nativeElement.value = ""
      // }
      // // document.getElementById(nextotp).focus();
      // // document.getElementById(nextotp).value = ;
      
    // }else{
      
    //   if ( charCode > 57 && charCode < 91 ){ //tab
    //     alert("must be number!")
    //   }
    //   this.otpinput[otpid] = ""
      
    // }
  }

  generatenew(){
    this.countTimeout = 30
    this.countdown()

    let ranstring:any = Math.floor(100000 + Math.random() * 900000);   
    ranstring = String(ranstring);
    ranstring = ranstring.substring(0,6);
    console.log("ranstring")
    // this.codeotpran = ranstring
    console.log(ranstring)
  
    const params = {
      "otp_code": ranstring,
      "phone_number": this.regis.phone_number,
      "prospekindex": this.prospekindex
    }
    this.rest.setOtpprospek(params).subscribe((response:any) => {
      //console.log(response)
      //console.log("siska2")
      //set otp
      if(response.status == true){
        this.codeotpran = response.data.otp_code
        //console.log(this.codeotpran)
        //console.log("siska")
        //console.log(params)
        this.sendSms(params)
      }else{
        console.log(response.message)
      }
    });

  }

  sendSms(dataPost:any){
    const params = {
      "code_otp": dataPost.otp_code,
      "phone_number": dataPost.phone_number,
      "prospek_index": dataPost.prospekindex
    }
    this.rest.sendSmsotp(params).subscribe((response:any) => {
      //set otp
      //console.log(response)
    });

  }

  countdown(){
    if(this.countTimeout == 0){
      this.generate1 = false
    }else{
      this.generate1 = true
      // console.log(this.count)
      setTimeout(()=>{
        this.countTimeout -=1
        this.countdown()
      }, 1000);
    }
  }

  nextToOrder(){
    if(this.prospekindex != 0){
      this.router.navigate(['regis2/', this.prospekindex]);
      if(!(this.prod == null)){
        this.router.navigate(['regis2/'+this.prospekindex], {queryParams:{
        prod:this.prod,
        addon:this.addon,
        period:this.period          
        }});
    }  
    }   
  }

  onNext(){
    // this.checkLatlon();
    // this.submitted = true;

    swal({
      title: "Apakah semua data sudah terisi lengkap?",
      text: "Proses akan di lanjutkan.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnClickOutside: false
    })
    .then((confirm:any) => {
        if (confirm) {
          if(
            this.regis.name == '' ||
            this.regis.email == '' ||
            this.regis.phone_number == '' ||
            this.regis.provincerow == '' ||
            this.regis.address == '' ||
            this.regis.cityrow == '' ||
            this.regis.home_number == '' ||
            this.regis.districtrow == '' ||
            this.regis.rt == '' ||
            this.regis.subdistrictrow == '' ||
            this.regis.rw == '' ||
            this.regis.postal_code == '' ||
            this.regis.identity_number == '' ||
          //  this.regis.identity_birth == '' ||

          //  this.regis.home_status == '' ||
          //  this.regis.home_type == '' ||
          //  this.regis.type_id == '' ||
          //  this.regis.type_relative == '' ||
            this.regis.agreeLocation == false

          ){
            swal({
              title: "Data kamu belum terisi dengan lengkap.",
              text: "Silahkan dilengkapi ya.",
              icon: "error",
            });
            return
          }

          if(this.regis.identity_image == ''){
            swal({
              title: "Upload foto KTP",
              text: "Maaf Data KTP harus di upload.",
              icon: "error",
            });
            return
          }
          

          if( this.regis.identity_birth == ''){
            this.regis.identity_birth = null
          }

          if( this.regis.identity_number == ''){
            this.regis.identity_number = null
          }

          if( this.regis.home_status == ''){
            this.regis.home_status = null
          }

          if( this.regis.home_type == ''){
            this.regis.home_type = null
          }

          if( this.regis.type_relative == ''){
            this.regis.type_relative = null
          }

          if( this.regis.phone_number.length <= 10){
            swal({
              title: "Data Celular/Whatsapp",
              text: "Maaf Data Celular/Whatsapp yang anda Input, minimal 10 angka.",
              icon: "error",
            });
            return
          }
          
          if(this.regis.whatsapp_number.length <= 10 && this.regis.whatsapp_number != ''){
            swal({
              title: "Data Whatsapp",
              text: "Maaf Data Whatsapp yang anda Input, minimal 10 angka.",
              icon: "error",
            });
            return
          }
          

          // this.loadingIcon.next = true
          const province = this.regis.provincerow.id
          const city = this.regis.cityrow.id
          const district = this.regis.districtrow.id
          const subdistrict = this.regis.subdistrictrow.id

          this.regis['identity_image'] = this.image
          this.regis['customer_type'] = 1 //inject residential
          this.regis['type_id'] = 1 // default KTP
          this.regis['province'] = province.toString()
          this.regis['city'] = city.toString()
          this.regis['district'] = district.toString()
          this.regis['subdistrict'] = subdistrict.toString()
          this.regis['latitude'] = this.latitude
          this.regis['longitude'] = this.longitude

          // console.log(this.regis)

          this.rest.setDataprospek(this.regis).subscribe((response:any) => {
            // console.log(response);

            if (response.status == true) {
              
              // Modal not work
              swal({
                title: "Terimakasih telah melengkapi data diri kamu",
                text: "Mohon menunggu proses Mohon menunggu data kamu sedang kami proses.",
                icon: "success",
              });
              
              this.loadingIcon.next = false
              this.loadingIcon.showFormOtp = true
              this.prospekindex = response.data.prospekindex
              this.generatenew()

              // alert(response.message + "\nMohon selanjutnya isi data diri dengan benar dan lengkap\n\nTerimakasih!")
              // this.router.navigate(['regis2/', response.data.prospekindex]);

            } else {
              // console.log('not cover');
              // alert(response.message + "\n\nTerimakasih!")     
              this.loadingIcon.showFormOtp = false 
              // swal({
              //   title: "Area tidak tercoverage",
              //   text: "Maaf, area kamu belum tercover. Nantikan keseruan bersama kami di waktu yang akan datang. Data anda tetap kami keep dan Kami akan menghubungi kembali, jika perluasan jangkauan daerah dari layanan MNC Play sudah sampai ke daerah mu, ya",
              //   icon: "error",
              // });
              swal({
                title: "Area tidak tercoverage",
                text: "Maaf ya, area kamu masih belum tercover saat ini.\n Data kamu sudah tersimpan dengan baik, buat kami tindaklanjuti kembali jika sudah ada perluasan jangkauan MNC Play.\n Yuk, berlangganan MNC Vision aja, buat beragam tayangan berkualitas paling oke punya! \n https://mncvision.id/ \n Kepoin juga media sosialnya di@mncvisionid",
                icon: "error",
                button: {confirm:true,text:"mncvision.id"},
              }).then((confirmrsp:any)=>{ 
                if(confirmrsp){
                  window.open("https://mncvision.id/")
                }
              });
              // this.router.navigate(['regis']);
              // this.ngOnInit();

            }
          });
        }
    })
  }

  // uploadtest(){
  //   this.regis['identity_image'] = this.image
  //   this.rest.uploadtest(this.regis['identity_image']).subscribe((response:any) => {
  //     console.log(response)
  //   })
  // }

  onReset(){
    // this.submitted = false;
    // this.router.navigate(['regis']);
    swal({
      title: "Are you sure?",
      text: "Form akan direset",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnClickOutside: false
    })
    .then((confirm) => {
      if (confirm) {
        this.ngOnInit()
      }
    })
  }  

  changeBase64($event:any) {
    this.fileData = <File>$event.target.files[0]
    this.preview()
    this.readThis($event.target)

    // setTimeout(() => {
    //   this.uploadtest()
    // }, 5000);
  }
  preview() {
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.fileData); 
    reader.onload = (_event) => { 
      this.previewUrl = reader.result; 
    }
  }

  readThis(inputValue: any): void {
    var file:File = inputValue.files[0];
    var myReader:FileReader = new FileReader();

    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.image = myReader.result;
       console.log(this.image)
    }
  }


  alertfailed(message:any){
    swal({
      title: "Gagal!",
      text: message,
      icon: "error"
    })
  }
  alertsuccess(message:any){
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
      // closeOnClickOutside: false
    })
  }
}
